/* import __COLOCATED_TEMPLATE__ from './sh-invoice-line-items-list.hbs'; */
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";

/**
 * This is the admin view for an sh-invoice's line items list view
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-sh-invoice-line-items-list'],

  /**
   * Register services
   */
  constants: service(),
  stateManager: service('state-managers/routes/admin/accounting/payin/sh-invoice'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * @param {ShInvoice}
   */
  shInvoice: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /**
   * @param {Boolean}       Set this to false if you do NOT want to see the 'Invoice #<ID>' heading
   */
  isShowInvoiceHeading: true,

  /**
   * @param {Function} onRemoveFromBatch
   */
  onRemoveFromBatch: () => {},

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Number}     Total amount of the invoice.
   */
  _totalAmount: readOnly('shInvoice.totalAmount'),

  actions: {
    /**
     *
     */
    onAddNewLineItemClicked: function() {
      let modalModel = {
        shInvoice: this.get('shInvoice'),
        onAddLineItemAdded: () => {
          this.get('stateManager').lineItemAdded();
        }
      };

      showModal(this, 'admin/edit-sh-billable-line-item-modal', modalModel);
    },

    onRemoveFromBatch: function() {
      this.get('onRemoveFromBatch')();
    },
  }
});
